define('admin-discussions-view',['controller', 'tooltip-notifier'], function(controller, tooltipNotifier) {

	function onDeletePostClick() {
		//TODO delete reason support

		var button = $(this);
		var id = button.data('post-id');

		$.ajax({
			url: '/forum/-/0/' + id + '/delete',
			type: 'POST',
			dataType: 'json'
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Fehler beim Löschen des Beitrags.', xhr);
		});
	}

	function onHidePostClick() {
		//TODO delete reason support

		var button = $(this);
		var id = button.data('post-id');

		$.ajax({
			url: '/forum/-/0/' + id + '/hide',
			type: 'POST',
			dataType: 'json'
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Fehler beim Verstecken des Beitrags.', xhr);
		});
	}

	function onRestorePostClick() {
		var button = $(this);
		var id = button.data('post-id');

		$.ajax({
			url: '/forum/-/0/' + id + '/show',
			type: 'POST',
			dataType: 'json'
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Fehler beim Wiederherstellen des Beitrags.', xhr);
		});
	}

	controller.on('admin/discussions/view', function() {
		$('.delete-forum-post-button').click(onDeletePostClick);
		$('.hide-forum-post-button').click(onHidePostClick);
		$('.restore-forum-post-button').click(onRestorePostClick);
	});
});

